export default __webpack_public_path__ + "static/media/arrow-thick-left.3f9a2936.svg";